import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/** @jsx jsx */
import React, { useEffect, useRef, useState } from 'react';
import { jsx } from '@emotion/react';
import Tooltip from '@atlaskit/tooltip';
import { constants } from '../../shared';
import { EmojiButton } from '../EmojiButton';
import { ShowMore } from '../ShowMore';
import * as styles from './styles';

/**
 * Test id for wrapper Selector div
 */
export var RENDER_SELECTOR_TESTID = 'render-selector';
/**
 * Reactions picker panel part of the <ReactionPicker /> component
 */
export var Selector = function Selector(_ref) {
  var emojiProvider = _ref.emojiProvider,
    onMoreClick = _ref.onMoreClick,
    onSelection = _ref.onSelection,
    showMore = _ref.showMore,
    _ref$pickerQuickReact = _ref.pickerQuickReactionEmojiIds,
    pickerQuickReactionEmojiIds = _ref$pickerQuickReact === void 0 ? constants.DefaultReactions : _ref$pickerQuickReact;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  /**
   * Collection of global DOM timeout ids when user selects emojis for animation display
   */
  var timeoutIds = useRef([]);

  /**
   * Clear the timeouts for the selected emojis when the component unmounts
   */
  useEffect(function () {
    var timeoutValues = timeoutIds.current;
    return function cleanup() {
      timeoutValues.forEach(clearTimeout);
    };
  }, []);

  /**
   * event handler when an emoji gets selected
   * @param item selected emoji
   * @param description depth detail of the selected emoji
   * @param event Dom event data
   */
  var onSelected = function onSelected(item, description, event) {
    timeoutIds.current.push(window.setTimeout(function () {
      onSelection(item, description, event);
    }, 250));
    setSelection(item);
  };

  /**
   * custom css styling for the emoji icon
   * @param index location of the emoji in the rendered list of items
   */
  var emojiStyleAnimation = function emojiStyleAnimation(index) {
    return {
      animationDelay: "".concat(index * 50, "ms")
    };
  };

  /**
   * Render the default emoji icon
   * @param emoji emoji item
   * @param index location of the emoji in the array
   */
  var renderEmoji = function renderEmoji(emoji, index) {
    var _emoji$id;
    return jsx("div", {
      key: (_emoji$id = emoji.id) !== null && _emoji$id !== void 0 ? _emoji$id : emoji.shortName,
      className: emoji === selection ? 'selected' : undefined,
      css: [styles.emojiStyle, styles.revealStyle],
      style: emojiStyleAnimation(index),
      "data-testid": RENDER_SELECTOR_TESTID
    }, jsx(Tooltip, {
      content: emoji.shortName
    }, jsx(EmojiButton, {
      emojiId: emoji,
      emojiProvider: emojiProvider,
      onClick: onSelected
    })));
  };
  return jsx("div", {
    css: styles.selectorStyle
  }, pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null, showMore ? jsx(ShowMore, {
    key: "more",
    buttonStyle: styles.revealStyle,
    style: {
      button: emojiStyleAnimation(constants.DefaultReactions.length)
    },
    onClick: onMoreClick
  }) : null);
};